import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { supabase } from "../../api/supabaseClient";
import { resetUserData } from "../user/UserSlice";
import { clearCart } from "../cart/Cart-Slice";
import { clearWishlist } from "../wishlist/WishlistSlice";

//data => {user: {…}, session: {…}}
// SignUp new user
export const signUp = createAsyncThunk(
  "auth/signUp",
  async ({ email, password }, { rejectWithValue , dispatch }) => {
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) return rejectWithValue(error.message);
    dispatch(resetUserData());
    return data;
  }
);
// user signIn
export const signIn = createAsyncThunk(
  "auth/signIn",
  async ({ email, password }, { rejectWithValue , dispatch }) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) {
      return rejectWithValue(error.message);
    }
    dispatch(resetUserData());
    return data;
  }
);
//user signOut
export const signOut = createAsyncThunk(
  "auth/signOut",
  async (_, { rejectWithValue , dispatch }) => {
    const { error } = await supabase.auth.signOut();
    dispatch(resetUserData());
    dispatch(clearCart());
    dispatch(clearWishlist());
    if (error) return rejectWithValue(error.message);
    return {};
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    loading: false,
    error: null,
    loginSuccess: false,

  },
  reducers: {
     resetLoginState: (state) => {
      state.loginSuccess = false; 
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // signUp cases
      .addCase(signUp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.loginSuccess = true; 
      })
      .addCase(signUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // signIn cases
      .addCase(signIn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.loginSuccess = true; 
      })
      .addCase(signIn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // signOut cases
      .addCase(signOut.pending, (state) => {
        state.loading = true;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
      })
      .addCase(signOut.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const {resetLoginState,setUser} = authSlice.actions;

export default authSlice.reducer;
